const URL_SPLIT_PATTERN = /(^(?:https?:)?\/{2,})?([^#?]*)([#?].*)?/;
const SLASH_PATTERN = /\/{2,}/g;
export const normalizeUrl = (...url) => (url.join("/").replace(URL_SPLIT_PATTERN, (m, p1, p2, p3) => [
    p1 && p1.replace(/\\/g, "/").replace(SLASH_PATTERN, "//"),
    p2 && p2.replace(/\\/g, "/").replace(SLASH_PATTERN, "/"),
    p3,
].filter(Boolean).join("")));
